import styled from "styled-components";
import { colors } from "../../../styles";

export const Container = styled.div`
  display: flex;
  color: ${colors.feedback};
  font-size: 14px;

  span {
    margin-left: 5px;
  }
`;
